/*
	Получаем список с историей чатов (сессий)
*/
import { useQuery } from "@tanstack/react-query";
import { listSessions } from "../../../../../../../../../shared/api/sessions";

// Функция для вызова API
export const fetchChatSessions = async (
	user_id: string,
	include_deleted?: boolean,
	limit?: number,
	cursor?: string | null,
) => {
	const data = await listSessions({ user_id, include_deleted, limit, cursor });
	return data;
};

// Кэширование
export const useChatSessions = (
	user_id?: string,
	include_deleted?: boolean,
	limit?: number,
	cursor?: string | null,
) => {
	return useQuery({
		queryKey: ["sessions-data", user_id, include_deleted, limit, cursor],
		queryFn: () => fetchChatSessions(user_id!, include_deleted, limit, cursor),
		enabled: Boolean(user_id),

		staleTime: 1000 * 30,
		refetchInterval: false,
		refetchOnWindowFocus: true,
	});
};
